<template>
	<div id="MobileLogin" v-if="device">
		<h2 class="sceneTitle"><img src="/static/img/mobile/title-connect.png" height="40" width="131" alt="連結裝置"></h2>
		<div class="loginBox">
			<p class="text">請輸入電腦顯示代碼<br>連結電腦進行遊戲</p>

			<p><input type="text" v-model="inputRoomCode" name=""></p>

			<router-link class="btn" v-if="roomExistAndGo" :to="'Game/' + roomExistAndGo" replace>連結裝置</router-link>
			<button class="btn" v-else>連結裝置</button>
		</div>
	</div>
	<div class="redirect" v-else>
		<div class="alert">
			<div class="alertBox">
				<p class="text alertType">請回首頁</p>
				<p class="text alertText">重新開始遊戲</p>
				<router-link class="btn" :to="'/'" replace><span>確定</span></router-link>
			</div>
		</div>
		<router-link v-if="!device" :to="'/'" replace>確定</router-link>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'MobileLogin',
		data () {
			return {
				inputRoomCode: '',
				roomExistAndGo: ''
			}
		},
		watch: {
			inputRoomCode: function (msg) {
				if (msg.length === 5) {
					socket.emit('checkRoomExist', msg.toLowerCase());
				} else {
					this.roomExistAndGo = "";
				}
			}
		},
		computed: {
			...mapGetters({
				device: 'isMobile'
			})
		},
		mounted () {
			let self = this;
			socket.removeAllListeners();
			socket.on('checkRoom', function (roomCode) {
				self.roomExistAndGo = roomCode;
			});
		},
		// sockets: {
		// 	'checkRoom': function (roomCode) {
		// 		this.roomExistAndGo = roomCode;
		// 	}
		// }
	}
</script>

<style lang="sass" scoped>
	%clearfix
		zoom: 1
		&::before
			content: ""
			display: table
		&::after
			content: ""
			display: table
			clear: both
	.redirect
		position: relative
		min-width: 1200px
		height: 100%
		background-repeat: no-repeat
		overflow: hidden
		-webkit-background-size: auto 250%
		-o-background-size: auto 250%
		background-size: auto 250%
		background-position: center center
		background-image: url(/static/img/bg-intro.jpg)
		-webkit-transform-origin: center top
		-moz-transform-origin: center top
		-ms-transform-origin: center top
		-o-transform-origin: center top
		transform-origin: center top
	.alert
		position: fixed
		top: 0
		left: 0
		width: 100%
		height: 100%
		background-color: rgba(0, 0, 0, 0.8)
		z-index: 999
		.alertBox
			position: absolute
			top: 0
			left: 0
			right: 0
			bottom: 0
			margin: auto
			width: 454px
			height: 434px
			text-align: center
			background-repeat: no-repeat
			background-position: center center
			background-image: url(/static/img/alert-box.png)
			.text
				margin: 0
				font-size: 25px
				color: #000
				line-height: 1.4em
			.alertType
				margin-top: 240px
			.btn
				margin-top: 20px
				position: relative
				-webkit-border-radius: 30px
				border-radius: 30px
				display: inline-block
				text-align: center
				padding: 2px
				text-decoration: none
				-webkit-box-shadow: #740F10 0 7px 0
				box-shadow: #740F10 0 7px 0
				background: #B22123
				background: -moz-linear-gradient(top, #B22123 0%, #CC3537 100%)
				background: -webkit-linear-gradient(top, #B22123 0%, #CC3537 100%)
				background: linear-gradient(to bottom, #B22123 0%, #CC3537 100%)
				&:active
					margin-top: 27px
					-webkit-box-shadow: none
					box-shadow: none
				span
					position: relative
					padding: 10px 56px
					-webkit-box-sizing: border-box
					-moz-box-sizing: border-box
					box-sizing: border-box
					font-weight: bold
					color: #FFF
					font-size: 26px
					background-color: #B22123
					display: block
					width: 100%
					height: 100%
					-webkit-border-radius: 30px
					border-radius: 30px
	#MobileLogin
		position: fixed
		top: 0
		left: 0
		width: 100%
		height: 100%
		text-align: center
		&::before
			position: absolute
			z-index: 0
			display: block
			content: ""
			top: 0
			bottom: 0
			left: 0
			right: 0
			margin: auto
			width: 100%
			height: 100%
			-webkit-background-size: auto 1400px
			-o-background-size: auto 1400px
			background-size: auto 1400px
			background-repeat: no-repeat
			background-position: center center
			background-image: url(/static/img/bg-intro.jpg)
		.sceneTitle
			position: absolute
			width: 131px
			height: 40px
			top: -350px
			bottom: 0
			left: 0
			right: 0
			margin: auto
		.loginBox
			position: absolute
			top: 20px
			bottom: 0
			left: 0
			right: 0
			margin: auto
			z-index: 1
			width: 308px
			height: 300px
			-webkit-background-size: 100%
			-o-background-size: 100%
			background-size: 100%
			background-repeat: no-repeat
			background-position: center center
			background-image: url(/static/img/mobile/scrollBox.png)
			.text
				font-size: 20px
				font-weight: bold
				text-align: center
				margin-top: 50px
			input
				display: block
				padding: 0
				border: 1px solid #C98A22
				-webkit-border-radius: 2px
				border-radius: 2px
				background-color: #FFF
				width: 150px
				height: 45px
				margin: 0 auto
				text-align: center
				color: #C98A22
				font-size: 20px
				letter-spacing: 0.1em
			.btn
				padding: 0
				border: 0
				margin: 0 auto
				display: block
				width: 150px
				height: 45px
				color: #000
				text-align: center
				text-decoration: none
				-webkit-border-radius: 30px
				border-radius: 30px
				font-size: 20px
				line-height: 45px
				font-weight: bold
				background-color: #F6B01A
				-webkit-box-shadow: #C18609 0 5px 0
				box-shadow: #C18609 0 5px 0
</style>


// WEBPACK FOOTER //
// MobileLogin.vue?63a0a67a